import { RootState } from "../../rootReducer";

export const selectIsUpdatingUserStatus = (state: RootState) =>
  state.updateUserStatus.loading;
export const updateUserStatusErrorMessage = (state: RootState) =>
  state.updateUserStatus.error;
export const updateUserStatusResponse = (state: RootState) =>
  state.updateUserStatus.updateUserStatusResponse;
